<!--  -->
<template>
 <div class="card-item">
  <div>
    <div class="card-item-title" v-if="(planCurrentPhases.sum )!== 0">
      <Row>
        <Col span="4">
          <span class="card-item-title-name">已完成事项</span>
        </Col>
        <Col span="16">
          <div class="card-item-title-box">
            <myplan-todo-progress :strokeColor="strokeColor" :sum="planCurrentPhases.sum" :finishCount="Number(planCurrentPhases.finishCount)"></myplan-todo-progress>
          </div>
        </Col>
      </Row>
    </div>
    <div class="history-collapse-style">
      <div class="collapse-commen-style">
        <Collapse  v-model="collapseMiddleActiveName" class="inner-collapse">
            <Panel :name="targetScoreItem.name" v-for="(targetScoreItem,targetScoreIndex) in planCurrentPhases.scoreInfos" :key="targetScoreIndex+'SCORE'">
                <div class="myplan-collapse-big-title">
                  <Row>
                    <Col :span="12">
                     <span class="title-first">{{targetScoreItem.name}}</span>
                    </Col>
                    <Col :span="10"><span>{{targetScoreItem.phasesName}}</span></Col>
                  </Row>
                </div>
                <div slot="content" v-for="(innerItem,innerIndex) in targetScoreItem.todos" :key="innerIndex">
                    <div class="myplan-collapse-content">
                      <div class="myplan-collapse-content-list"  v-for='(innerScoreItem,innerScoreIndex) in targetScoreItem.todos' :key="'SCORE'+innerScoreIndex">
                        <div class="center-flex dis_15">
                          <Row style="width:100%;">
                          <Col :span="12">
                          <Icon type="ios-checkbox-outline" class="icon-color-checkbox icon-boxs" v-if="innerScoreItem.finish"></Icon>
                          <Icon type="ios-square-outline" class="icon-color no-finish-icon icon-boxs" v-else></Icon>
                          <!-- <Checkbox v-model="innerScoreItem.finish" @on-change="planMenteeFinishTodos(innerScoreItem.id,innerScoreIndex,'SCORE')" v-if="!isEdit"></Checkbox> -->
                          <span :class="{'checkbox-line':innerScoreItem.finish}" class="color_333 margin_left_10">{{innerScoreItem.name}}</span>
                          </Col>
                           <Col :span="8">
                            <span>{{innerScoreItem.phasesName}}&nbsp;&nbsp;{{getTime(innerScoreItem.completionTime)}}</span>
                          </Col>
                          </Row>
                        </div>
                        <!-- <Checkbox v-model="innerScoreItem.finish"  @on-change="planMenteeFinishTodos(innerScoreItem.id,innerScoreIndex,'OTHER')" class="checkout-box-icon"></Checkbox> -->
                        <!-- <span :class="{'checkbox-line':innerScoreItem.finish}" class="color_333">{{innerScoreItem.name}}</span> -->
                      </div>
                    </div>
                </div>
            </Panel>
            <Panel :name="targetItem.name" v-for="(targetItem,targetIndex) in planCurrentPhases.targetInfos" :key="'OTHER'+targetIndex">
                <div class="myplan-collapse-big-title">
                   <Row>
                    <Col :span="12">
                     <span class="title-first">{{targetItem.name}}</span>
                    </Col>
                    <Col :span="10"><span>{{targetItem.phasesName}}</span></Col>
                  </Row>
                </div>
                <div slot="content">
                    <div class="myplan-collapse-content">
                      <div v-for='(innerItem,innerIndex) in targetItem.todos' :key="'OTHER'+innerIndex" class="myplan-collapse-content-list">
                        <div class="center-flex dis_15">
                         <Row style="width:100%;">
                          <Col :span="12">
                          <span>
                            <Icon type="ios-checkbox-outline" class="icon-color-checkbox icon-boxs" v-if="innerItem.finish"></Icon>
                            <Icon type="ios-square-outline" class="icon-color no-finish-icon icon-boxs" v-else></Icon>
                            <!-- <Checkbox v-model="innerItem.finish" @on-change="planMenteeFinishTodos(innerItem.id,innerIndex,'OTHER')" v-if="!isEdit"></Checkbox> -->
                          </span>
                          <span  class="color_333 margin_left_10" :class="{'checkbox-line':innerItem.finish}">{{innerItem.name}}</span>
                           </Col>
                           <Col :span="8">
                            <span>{{innerItem.phasesName}}&nbsp;&nbsp;{{getTime(innerItem.completionTime)}}</span>
                          </Col>
                          </Row>
                        </div>
                        <!-- <Checkbox v-model="innerItem.finish"  @on-change="planMenteeFinishTodos(innerItem.id,innerIndex,'OTHER')" class="checkout-box-icon"></Checkbox>
                        <span :class="{'checkbox-line':innerItem.finish}" class="color_333">{{innerItem.name}}</span> -->
                      </div>
                    </div>
                </div>
            </Panel>
        </Collapse>
      </div>
    </div>
  </div>
 </div>
</template>
<script>
// components
import MyplanTodoProgress from './myplan-todo-progress'
import { date2String } from '@/libs/tools'
export default {
  name: '',
  components: {
    MyplanTodoProgress
  },
  props: ['planCurrentPhases'],
  data () {
    return {
      // 横向进度条的颜色
      strokeColor: '#6589dd',
      // 折叠
      collapseMiddleActiveName: '1'
    }
  },
  computed: {},
  mounted () {},
  methods: {
    // 处理时间
    getTime (time) {
      return time ? date2String(time) : ''
    }
  }
}
</script>
<style lang="less">
  .collapse-commen-style{
    //复选框选中样式
    .ivu-checkbox-checked .ivu-checkbox-inner:after{
      border-color:#6589DD;
    }
    .ivu-checkbox-checked .ivu-checkbox-inner{
      border-color:#6589DD;
      background-color: #E9EEF9;
    }
    // 折叠面板的样式
    .ivu-collapse{
      border:none;
      background-color:#FFFFFF;
    }
    .ivu-collapse>.ivu-collapse-item>.ivu-collapse-header {
      display: flex;
      align-items: center;
      border-bottom:none;
      padding-left:0;
      font-size:18px;
    }
    .ivu-collapse-content{
      background-color:#FFFFFF;
    }
    .ivu-collapse>.ivu-collapse-item{
      border-top:none;
      margin-bottom:15px;
    }
    .ivu-icon-ios-arrow-forward:before{
      content: "\F341";
    }
    .ivu-collapse>.ivu-collapse-item>.ivu-collapse-header>i{
      color:#6589DD;
      font-size:28px;
      margin-top: -3px;
    }
    .ivu-collapse-content>.ivu-collapse-content-box{
      padding-top: 12px;
      padding-bottom: 12px;
    }
}
</style>
<style lang='less' scoped>
.card-item {
  &-title{
    padding:0 58px 43px;
    border-bottom:1px solid #EFEFEF;
    &-name{
      font-size:24px;
    }
    &-box{
      margin-top:5px;
    }
  }
}
.history-collapse-style{
  padding:45px 58px 0;
  .myplan-collapse-content{
    padding:0 26px;
  }
  .myplan-collapse-big-title{
    width:100%;
  }
}
// 展示完成
.margin_left_10{
  margin-left:18px;
}
.icon-boxs{
  font-size:16px;
}
.dis_15{
  margin-bottom:10px;
}
</style>
